<div class="goals__form-card surface-card">
  <div class="goals__form-header">
    <div>
      <h2>{{ formTitleKey | translate }}</h2>
      <p>{{ 'goals.form.description' | translate }}</p>
    </div>
    <button type="button" class="ghost-btn compact" (click)="cancel()" aria-label="{{ 'goals.actions.close' | translate }}">×</button>
  </div>

  <form class="goals__form" [formGroup]="goalForm" (ngSubmit)="submit()">
    <div class="goals__form-field" *ngIf="hasGlobalDataScope">
      <span>Owner</span>
      <app-custom-select
        formControlName="ownerEntitySelect"
        [options]="ownerEntityOptions"
        placeholder="Seleziona un'entità">
      </app-custom-select>
      <small class="field-error"
             *ngIf="goalForm.get('ownerEntitySelect')?.invalid && goalForm.get('ownerEntitySelect')?.touched">
        Seleziona un owner
      </small>
    </div>

    <label class="goals__form-field">
      <span>{{ 'goals.form.nameField' | translate }}</span>
      <input type="text" formControlName="description" [placeholder]="'goals.form.namePlaceholder' | translate">
    </label>

    <label class="goals__form-field">
      <span>{{ 'goals.form.type' | translate }}</span>
      <app-custom-select
        formControlName="type"
        [options]="goalTypeOptions"
        [placeholder]="'goals.form.select' | translate">
      </app-custom-select>
      <small *ngIf="selectedGoalType?.Tip">{{ selectedGoalType?.Tip }}</small>
    </label>

    <ng-container *ngIf="selectedGoalType?.Type === 'customvariablelist'">
      <label class="goals__form-field">
        <span>{{ 'goals.form.customVarName' | translate }}</span>
        <app-custom-select
          formControlName="customVarName"
          [options]="customVarNameOptions"
          [placeholder]="'goals.form.select' | translate">
        </app-custom-select>
      </label>

      <label class="goals__form-field">
        <span>{{ 'goals.form.customVarOperator' | translate }}</span>
        <app-custom-select
          formControlName="customVarOperator"
          [options]="customVarOperatorOptions"
          [placeholder]="'goals.form.select' | translate">
        </app-custom-select>
        <small *ngIf="isRawRegExpOperator">{{ 'goals.form.regexpHint' | translate }}</small>
        <small *ngIf="isNoValueOperator">{{ 'goals.form.isNotEmptyHint' | translate }}</small>
      </label>

      <div class="goals__form-field" *ngIf="!isNoValueOperator">
        <span>{{ 'goals.form.customVarValue' | translate }}</span>

        <div class="value-tags" *ngIf="customVarValues.length">
          <span class="tag-chip" *ngFor="let value of customVarValues; let i = index">
            {{ value }}
            <button type="button" (click)="removeCustomVarValue(i)" aria-label="Remove">
              ×
            </button>
          </span>
        </div>

        <div class="value-add">
          <div class="value-add__controls">
            <input type="text"
                   #valueInput
                   [placeholder]="(isRawRegExpOperator ? 'goals.form.addRegExpPlaceholder' : 'goals.form.addValuePlaceholder') | translate"
                   (keydown.enter)="addCustomVarValue(valueInput.value) ? (valueInput.value='') : null; $event.preventDefault();">
            <button type="button" class="ghost-btn compact" (click)="addCustomVarValue(valueInput.value) ? (valueInput.value='') : null">
              {{ 'goals.form.addValue' | translate }}
            </button>
          </div>
          <small class="field-error" *ngIf="valueError">{{ valueError }}</small>
        </div>
      </div>

      <ng-container *ngTemplateOutlet="rulePreview"></ng-container>
    </ng-container>

    <ng-container *ngIf="selectedGoalType?.Type === 'url'">
      <label class="goals__form-field">
        <span>{{ 'goals.form.urlOperator' | translate }}</span>
        <app-custom-select
          formControlName="urlOperator"
          [options]="urlOperatorOptions"
          [placeholder]="'goals.form.select' | translate">
        </app-custom-select>
        <small *ngIf="isRawRegExpOperator">{{ 'goals.form.regexpHint' | translate }}</small>
      </label>

      <div class="goals__form-field">
        <span>{{ 'goals.form.urlValue' | translate }}</span>

        <div class="value-tags" *ngIf="urlValues.length">
          <span class="tag-chip" *ngFor="let value of urlValues; let i = index">
            {{ value }}
            <button type="button" (click)="removeUrlValue(i)" aria-label="Remove">
              ×
            </button>
          </span>
        </div>

        <div class="value-add">
          <div class="value-add__controls">
            <input type="text"
                   #urlValueInput
                   [placeholder]="(isRawRegExpOperator ? 'goals.form.addRegExpPlaceholder' : 'goals.form.addValuePlaceholder') | translate"
                   (keydown.enter)="addUrlValue(urlValueInput.value) ? (urlValueInput.value='') : null; $event.preventDefault();">
            <button type="button" class="ghost-btn compact" (click)="addUrlValue(urlValueInput.value) ? (urlValueInput.value='') : null">
              {{ 'goals.form.addValue' | translate }}
            </button>
          </div>
          <small class="field-error" *ngIf="valueError">{{ valueError }}</small>
        </div>
      </div>

      <ng-container *ngTemplateOutlet="rulePreview"></ng-container>
    </ng-container>

    <!--
      Cosa viene davvero salvato. Con un operatore letterale i metacaratteri del valore
      vengono escapati: la regola resta valida per BigQuery ma cerca una stringa letterale,
      e senza questo blocco lo scarto si scopre solo leggendo la riga su MySQL.
    -->
    <ng-template #rulePreview>
      <div class="goals__rule-preview" *ngIf="compiledPattern">
        <small class="field-warning" *ngIf="literalValuesLookLikeRegExp">
          {{ 'goals.form.literalMetacharsWarning' | translate }}
        </small>
        <small>{{ 'goals.form.compiledRuleLabel' | translate }}</small>
        <code>{{ compiledPattern }}</code>
      </div>
    </ng-template>

    <!-- Advanced (Console) raw-rule editor for the extra goal types (path, custom_data, …). -->
    <ng-container *ngIf="advanced && isGenericRuleType">
      <label class="goals__form-field">
        <span>{{ 'goals.form.rule' | translate }}</span>
        <textarea formControlName="rule" rows="4" [placeholder]="'goals.form.ruleHint' | translate"></textarea>
      </label>
      <label class="goals__form-checkbox">
        <input type="checkbox" formControlName="isRegExp">
        <span>{{ 'goals.form.isRegExp' | translate }}</span>
      </label>
    </ng-container>

    <label class="goals__form-checkbox" *ngIf="advanced">
      <input type="checkbox" formControlName="showInDashboard">
      <span>{{ 'goals.form.showInDashboard' | translate }}</span>
    </label>

    <div class="goals__form-actions">
      <button type="button" class="ghost-btn" (click)="cancel()">{{ 'goals.actions.cancel' | translate }}</button>
      <button type="submit" class="primary-btn" [disabled]="saving">
        {{ saving ? ('goals.states.saving' | translate) : ('goals.actions.save' | translate) }}
      </button>
    </div>
  </form>
</div>
